import BigNumber from 'bignumber.js';
import { Formatter } from 'recharts/types/component/DefaultTooltipContent';

const getLabel = (label: string) => {
  switch (label) {
    case 'dealSpending':
      return 'Deal Spending';
    case 'paygSpending':
      return 'PAYG Spending';
    default:
      return label;
  }
};

const MIN_DISPLAY_VALUE = 0.01;

export const spendingValueFormatter: Formatter<string, string> = (
  value: string,
  label: string,
) => {
  let formattedValue;

  if (Number(value) < MIN_DISPLAY_VALUE) {
    formattedValue = new BigNumber(value).toFormat();
  } else {
    formattedValue = new BigNumber(value).decimalPlaces(2).toFormat();
  }

  return [`$${formattedValue}`, getLabel(label)];
};
